import { render, staticRenderFns } from "./GalleryPage.vue?vue&type=template&id=d50f419e&scoped=true&"
import script from "./GalleryPage.vue?vue&type=script&lang=js&"
export * from "./GalleryPage.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPage.vue?vue&type=style&index=0&id=d50f419e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50f419e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VLayout,VMain,VSheet})
